import { Progress } from '@/components/ui/progress';
import { useEffect, useState } from 'react';

import SlideImg1 from '@/assets/images/slide-img-1.jpg';
import SlideImg2 from '@/assets/images/slide-img-2.jpg';
import SlideImg3 from '@/assets/images/slide-img-3.jpg';
import SlideImg4 from '@/assets/images/slide-img-4.jpg';
import SlideImg5 from '@/assets/images/slide-img-5.jpg';

const slides = [
  {
    image: SlideImg1,
    title: 'YOUR FITNESS, YOUR RULES',
    subTitle: '1:1 TRAINING, ANYWHERE, 24x7',
    description: 'Experience personalized fitness coaching that fits your schedule and location.',
  },
  {
    image: SlideImg2,
    title: 'CUSTOMIZED WORKOUT PLANS',
    subTitle: 'TAILORED TO YOUR UNIQUE GOALS',
    description:
      'Our expert trainers design sessions specifically for your strength, flexibility, or wellness objectives.',
  },
  {
    image: SlideImg3,
    title: 'TRAIN ANYWHERE, ANYTIME',
    subTitle: 'NO GYM? NO PROBLEM!',
    description:
      'Enjoy the freedom to work out at home, in a hotel, or outdoors—no equipment needed.',
  },
  {
    image: SlideImg4,
    title: 'FLEXIBLE AND AFFORDABLE PRICING',
    subTitle: 'NO LONG-TERM COMMITMENTS',
    description: 'Choose pay-as-you-go packages that suit your needs and budget.',
  },
  {
    image: SlideImg5,
    title: 'START YOUR JOURNEY TODAY',
    subTitle: 'SCHEDULE A FREE SESSION—NO CREDIT CARD REQUIRED',
    description:
      'Kickstart your fitness transformation with a complimentary session, no strings attached.',
  },
];

export default function Slider() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          setCurrentSlide((prevSlide) => {
            const nextSlide = (prevSlide + 1) % slides.length;
            return nextSlide;
          });
          return 0; // Reset progress only after switching slides
        }
        return oldProgress + 1;
      });
    }, 100);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className='w-full h-[95%] max-w-3xl mx-auto overflow-hidden rounded-2xl'>
      <div className='p-0 relative h-full border-0 rounded-2xl'>
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`absolute top-0 left-0 w-full h-full transition-opacity border-0 duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={slide.image}
              alt={slide.title}
              className='w-full h-full object-cover border-0'
            />
            <div className='flex flex-col absolute bottom-0 left-0 border-0 right-0 bg-gradient-to-t from-black to-transparent p-6 text-white'>
              <div className='flex gap-2 mb-5'>
                {slides.map((_, i) => (
                  <Progress
                    key={i}
                    value={currentSlide === i ? progress : i < currentSlide ? 100 : 0}
                    className='w-12 h-[5px] rounded-full z-10'
                  />
                ))}
              </div>
              <h1 className='font-bold'>{slide.title}</h1>
              <h3 className='font-bold mt-2'>{slide.subTitle}</h3>
              <p className='font-normal text-sm mt-3'>{slide.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
